// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pageTitle{
    color: var(--admin-color);
    font-size: 18px !important;
    font-weight: 500 !important;
    text-transform: capitalize;
    margin-left: 30px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Global/PageTitle/PageTitle.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,2BAA2B;IAC3B,0BAA0B;IAC1B,iBAAiB;AACrB","sourcesContent":[".pageTitle{\n    color: var(--admin-color);\n    font-size: 18px !important;\n    font-weight: 500 !important;\n    text-transform: capitalize;\n    margin-left: 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
